if (!customElements.get('back-in-stock-request')) {
  customElements.define(
    'back-in-stock-request',
    class BackInStockRequest extends HTMLElement {
      constructor() {
        super();
        this.available = this.dataset.available === 'true';
        this.sectionId = this.dataset.sectionId;
        this.variantId = this.dataset.variantId || '';
        this.variantTitle = this.dataset.variantTitle || '';
        this.productTitle = this.dataset.productTitle || '';
        this.productUrl = this.dataset.productUrl || window.location.href.split('?')[0];
      }

      connectedCallback() {
        this.sectionRoot = document.getElementById(`theme-section-${this.sectionId}`);
        this.mainProductRoot = document.getElementById(`MainProduct-${this.sectionId}`) || this.sectionRoot;
        this.purchaseControls = this.sectionRoot?.querySelector('[data-hala-purchase-controls]');
        this.opener = this.querySelector('[data-back-in-stock-opener]');
        this.modal = document.querySelector(this.dataset.modalSelector);

        this.updateUI();
        this.subscribeToVariantChanges();
        this.observeReleasit();
        this.openModalAfterFormPost();
      }

      disconnectedCallback() {
        if (typeof this.unsubscribeVariantChange === 'function') this.unsubscribeVariantChange();
        if (this.releasitObserver) this.releasitObserver.disconnect();
      }

      subscribeToVariantChanges() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const data = event?.data;
          if (!data || String(data.sectionId) !== String(this.sectionId) || !data.variant) return;

          this.available = Boolean(data.variant.available);
          this.variantId = String(data.variant.id || '');
          this.variantTitle = data.variant.title === 'Default Title' ? '' : (data.variant.title || '');
          this.updateUI();
        });
      }

      updateUI() {
        const soldOut = !this.available;

        if (this.purchaseControls) this.purchaseControls.hidden = soldOut;
        if (this.opener) this.opener.hidden = !soldOut;
        if (this.sectionRoot) this.sectionRoot.classList.toggle('hala-product-is-sold-out', soldOut);

        const stickyCart = document.getElementById(`sticky-cart-${this.sectionId}`);
        if (stickyCart) stickyCart.hidden = soldOut;

        this.updateFormDetails();
        this.updateReleasitVisibility();
      }

      updateFormDetails() {
        if (!this.modal) this.modal = document.querySelector(this.dataset.modalSelector);
        if (!this.modal) return;

        const variantLabel = this.modal.querySelector('[data-back-in-stock-variant-label]');
        const variantInput = this.modal.querySelector('[data-back-in-stock-variant-input]');
        const urlInput = this.modal.querySelector('[data-back-in-stock-url-input]');
        const bodyInput = this.modal.querySelector('[data-back-in-stock-body-input]');
        const variantUrl = this.variantId ? `${this.productUrl}?variant=${this.variantId}` : this.productUrl;

        if (variantLabel) {
          variantLabel.textContent = this.variantTitle;
          variantLabel.hidden = !this.variantTitle;
        }
        if (variantInput) variantInput.value = this.variantTitle;
        if (urlInput) urlInput.value = variantUrl;
        if (bodyInput) {
          bodyInput.value = `طلب إبلاغ عند توفر المنتج: ${this.productTitle}${this.variantTitle ? ` - ${this.variantTitle}` : ''}`;
        }
      }

      updateReleasitVisibility() {
        const soldOut = !this.available;
        const selectors = [
          '#rsi_buy_now_button',
          '#rsi-button-hook',
          '#buttonContainerProduct',
          '#rsi_form_wrapper',
          '#_rsi-cod-form-embed-custom-hook',
          '._rsi-buy-now-button-app-block-hook',
          '._rsi-buy-now-button-form-block-hook',
          '._rsi-cod-form-gempages-button-overwrite',
          '._rsi-cod-form-pagefly-button-overwrite-v2'
        ];

        if (this.mainProductRoot) {
          this.mainProductRoot.querySelectorAll(selectors.join(',')).forEach((element) => {
            element.classList.toggle('hala-rsi-hidden-out-of-stock', soldOut);
          });
        }

        document.querySelectorAll('#floatingBuyNowButton').forEach((element) => {
          element.classList.toggle('hala-rsi-hidden-out-of-stock', soldOut);
        });
      }

      observeReleasit() {
        if (!this.mainProductRoot || typeof MutationObserver === 'undefined') return;

        this.releasitObserver = new MutationObserver(() => this.updateReleasitVisibility());
        this.releasitObserver.observe(this.mainProductRoot, { childList: true, subtree: true });
      }

      openModalAfterFormPost() {
        if (!this.modal || !this.modal.querySelector('[data-back-in-stock-form-status]')) return;

        window.setTimeout(() => {
          if (typeof this.modal.show === 'function') this.modal.show(this.opener?.querySelector('button'));
        }, 150);
      }
    }
  );
}
